import { IntegrationLayoutsEnum } from 'integration/IntegrationLayouts.enum';
import { integrationSubscribedToHistoryAction } from 'common/actions/integration';
import { exchangeMessageModel } from 'integration/exchangeMessage.model';

/**
 * @param {integrationModel} integration
 * @return {boolean}
 */
export function isIframe(integration) {
  return IntegrationLayoutsEnum.IFRAME === integration.layout;
}

function getIframeQuerystring({ portalUrl }) {
  return `?portalUrl=${encodeURIComponent(portalUrl)}`;
}

/**
 * @param {*} props
 * @param {integrationModel} urlQueryParams
 */
export function establishCommunicationChannelWithParentFrame(props, urlQueryParams) {
  if (urlQueryParams.layout === IntegrationLayoutsEnum.IFRAME) {
    const search = getIframeQuerystring(props.integration);

    if (!props.integration.subscribedToHistory) {
      props.history.listen((location, action) => {
        if (action !== 'REPLACE') {
          window.parent.postMessage(
            exchangeMessageModel({
              event: urlQueryParams.exchangeEventName,
              payload: {
                routeChanged: location.pathname + location.search,
              },
            }),
            '*'
          );
        }

        if (!location.search) {
          window.history.replaceState('', '', search);
        }
      });

      props.dispatch(integrationSubscribedToHistoryAction());
    }
  }
}
